// extracted by mini-css-extract-plugin
export default {"gridStyling":"views-ContentPage-components-themes-BGH-productsCardGrid__gridStyling--bg80c"};